// extracted by mini-css-extract-plugin
module.exports =  {"label":"LFHYTyH0q5gO09h9j44u","data":"V6JO6vikIGN2djv8BDAQ"};